import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import GameContainer from "../components/games/game_container/GameContainer";
import ShowContainer from "../components/mui/ShowContainer";
import { getUuid } from "../utils/utils";
import { useReadLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME } from "../store/enums";
import { API_CASINO } from "../api/casino.js";
import useNavigateWithSearch from "../hooks/useNavigateWitchSearch.js";
import { errorToast } from "../components/mui/Toaster.jsx";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../store/index.ts";

export default function BonusGame() {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigateWithSearch();
  const currency = useAppSelector((state) => state.user.currency);
  const saveGame = useReadLocalStorage(ENUM_LCS_NAME.saveGame);
  const saveGameUid = saveGame?.uid;

  const [currentGame, setCurrentGame] = useState(null);
  const newUid = useMemo(() => saveGameUid || getUuid(), [saveGameUid]);

  useEffect(() => {
    if (!id) return;

    API_CASINO.list
      .games({ gameId: id, currency })
      .then((e) => {
        const list = e.data.list;
        if (!list.length) {
          navigate("/");
          errorToast(t("A game with this ID was not found."));
          return;
        }
        const currentGame = list.find((el) => el.game_id == id);
        setCurrentGame(currentGame);
      })
      .catch(console.error);
  }, [id]);

  return (
    <ShowContainer condition={currentGame}>
      <GameContainer
        gameId={currentGame?.game_id}
        currentGame={currentGame}
        isBonus={true}
        uid={newUid}
      />
    </ShowContainer>
  );
}
